angular.module("correspondence")

    .controller("CorrespondenceListCtrl", ['LoginService', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$state', 'datasetsService', function (LoginService, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, gridService, modalService, $uibModal, $filter, $translate, $state, datasetsService) {

        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("CORRESPONDENCE_WRITE");

        $rootScope.title = $filter('translate')('correspondence.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('correspondence.title') }
        ];

        let pigstoShowInList = [];
        $scope.search = { status: "pending"};

        let loadCombos = function () {
            Restangular.all('CorrespondencesTypes').getList().then(function (results) {

                $scope.correspondencesTypes = results;
                $scope.correspondencesTypes.unshift({
                    id: null,
                    name: $filter('translate')('correspondence.allTypes')
                });
            });
            Restangular.all('correspondences/senders').getList().then(function (searchTerms) {
                $scope.senders = searchTerms;
            });

            Restangular.all('correspondences/recipients').getList().then(function (searchTerms) {
                $scope.recipients = searchTerms;
            });

            Restangular.all('correspondences/senders/positions').getList().then(function (searchTerms) {
                 $scope.senderPositions = searchTerms;
            });

            var optionsPIGa = { entity_type: "correspondence" };

            Restangular.all('InformationsGroups').getList(optionsPIGa).then(function (personsInformationGroups) {

                $scope.personsInformationGroups = personsInformationGroups;

                angular.forEach($scope.personsInformationGroups, function (pig) {
                    if (pig.configuration != "") pig.configuration = JSON.parse(pig.configuration);
                });

                $scope.checkboxSimpleOptions = [
                    { option: null, label: $filter('translate')('informations.all'), checked: true },
                    { option: true, label: $filter('translate')('events.staff.yes'), checked: false },
                    { option: false, label: $filter('translate')('events.staff.no'), checked: false }
                ];

                pigstoShowInList = $scope.personsInformationGroups.filter(function (el) { return el.notify_in_list; });//para saber si mostrar o no lo columna.
            });

        }

        loadCombos();

       // $scope.gridOptionsCorrespondence.columnDefs[4].visible = ($scope.search.status !== "pending");    

        $scope.loadData = function () {
            if (angular.isDefined($scope.gridOptionsCorrespondence)) {
                $scope.gridOptionsCorrespondence.loadData(false);
            } else {
                $scope.gridOptionsCorrespondence = {
                    pdfTitle: $filter('translate')('correspondence.pdf_title'),
                    exporterMenuCsv: true,
                    enableGridMenu: true,
                    gridMenuShowHideColumns: false,
                    enableSorting: true,
                    paginationPageSizes: [50, 100, 200],
                    paginationPageSize: 100,
                    rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                    onRegisterApi: function (gridApi) {
                        this.gridApi = gridApi;
                    },
                    columnDefs: [
                        { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                        {
                            name: 'date_celebration', displayName: $filter('translate')('correspondence.date_celebration'), width: 120,
                            type: 'date', cellFilter: 'toLocalDate | date:\'dd/MM/yyyy\''
                        },
                        {
                            name: 'hide_from_pending_report', width: 25, field: 'hide_from_pending_report', displayName: "", enableFiltering: false, enableHiding: false, enableColumnMenu: false,
                            cellTemplate: '<div  class="ui-grid-cell-contents">' +
                                '<i class="fa fa-eye-slash text-primary" ng-if="row.entity.hide_from_pending_report" ></i>' +
                                '</div>',
                            visible: ($rootScope.sizeSm || $rootScope.sizeXs || $rootScope.sizeMd ? false : true)
                        },
                        {
                            name: 'from_name_show', displayName: $filter('translate')('correspondence.from_person_id'), enableFiltering: false, enableHiding: true, width: 150,
                            cellTemplate: '<div popover-placement=\"top\" popover-append-to-body=\"true\" type=\"button\" popover-trigger=\"mouseenter\" uib-popover=\"{{grid.getCellValue(row, col)}}\" class="ui-grid-cell-contents">' +
                                '<span >{{grid.getCellValue(row, col)}}</span>' +
                                '</div>'                        
                        },
                        {
                            name: 'from_position_name', displayName: $filter('translate')('persons.position'), enableFiltering: false, enableHiding: true, width: 250,
                            cellTemplate: '<div popover-placement=\"top\" popover-append-to-body=\"true\" type=\"button\" popover-trigger=\"mouseenter\" uib-popover=\"{{grid.getCellValue(row, col)}}\" class="ui-grid-cell-contents">' +
                                '<span >{{grid.getCellValue(row, col)}}</span>' +
                                '</div>'
                        },
                        {
                            name: 'correspondence_type_name', displayName: $filter('translate')('correspondence.correspondence_type'), enableFiltering: false, enableHiding: true, width: 100,
                            cellTemplate: '<div popover-placement=\"top\" popover-append-to-body=\"true\" type=\"button\" popover-trigger=\"mouseenter\" uib-popover=\"{{grid.getCellValue(row, col)}}\" class="ui-grid-cell-contents">' +
                                '<span >{{grid.getCellValue(row, col)}}</span>' +
                                '</div>'                        
                        },
                        {
                            name: 'description_plain', displayName: $filter('translate')('correspondence.description'), enableFiltering: true, enableHiding: true, width: 350,
                            cellTemplate: '<div popover-placement=\"top\" popover-append-to-body=\"true\" type=\"button\" popover-trigger=\"mouseenter\" uib-popover=\"{{grid.getCellValue(row, col)}}\" class="ui-grid-cell-contents">' +
                                '<span >{{grid.getCellValue(row, col)}}</span>' +
                                '</div>'
                        },
                        {
                            name: 'attachtment', displayName: $filter('translate')('correspondence.attachtment'), enableFiltering: true, enableHiding: true, width: 70,
                            cellTemplate: '<div ng-if="row.entity.total_files > 0" class="fa fa-paperclip fa-lg"></div>'
                        },
                        {
                            name: 'tasksStatus', displayName: $filter('translate')('correspondence.tasksStatus'), enableFiltering: true, enableHiding: true, width: 70,
                            cellTemplate: '<div ng-if="row.entity.total_tasks_pending > 0"><i class="fa fa-circle" style="color:orange"></i>'
                        },

                        {
                            name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                                { title: $filter('translate')('correspondence.button_edit'), action: 'ng-click="grid.appScope.goToEdit(row.entity)"', cssIconClass: "fa fa-edit", cssClass: "btn btn-xs btn-white btn-ouline btn-custom-laptop" },
                                { title: $filter('translate')('correspondence.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove", cssClass: "btn btn-xs btn-white btn-ouline btn-custom-laptop" }
                            ], { cssClass: "pull-right" })
                        },
                    ],
                    getData: function (options) {

                        options.status = $scope.search.status;
                        options.date_from = $scope.search.date_from;
                        options.date_to = $scope.search.date_to;
                        options.date_celebration_from = $scope.search.date_celebration_from;
                        options.date_celebration_to = $scope.search.date_celebration_to;
                        options.name = $scope.search.name;
                        options.correspondence_type_id = $scope.search.correspondence_type_id;

                        // Revisar esto para arreglar filtros
                        addSpecialFiltersToOptions(options);
                        //
                        var pigs = "";
                        for (var key in $scope.search.pigs) {
                            if (typeof $scope.search.pigs[key] != "undefined" && $scope.search.pigs[key] != "" && $scope.search.pigs[key] != null) {
                                if (typeof ($scope.search.pigs[key]) == "object") {
                                    //estamos en el selector simple.
                                    var infoFilter = $scope.personsInformationGroups.filter(function (el) { return el.id == key; });
                                    if (infoFilter.length === 1) {
                                        if (infoFilter[0].type == "datetime") {
                                            if ($scope.search.pigs[key] != null) pigs += (pigs != "" ? "#" : "") + key + "=>" + new Date($scope.search.pigs[key]).toISOString();
                                        } else if (infoFilter[0].type == "checkboxSimple") {
                                            if ($scope.search.pigs[key].checked != "") pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.search.pigs[key].checked;
                                        } else {
                                            pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.search.pigs[key];
                                        }
                                    }
                                } else {
                                    pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.search.pigs[key];
                                }
                            }
                        }

                        options.pigs = pigs;

                        var deferred = $q.defer();

                        Restangular.all('Correspondences').getList(options).then(function (results) {

                            $scope.correspondences = results;
                            //guardamos opciones
                            options._pages = results.length;
                            localStorage.setItem("correspondences_options", JSON.stringify(options));

                            deferred.resolve(results);

                        });

                        return deferred.promise;

                    }
                };
                //$scope.gridOptionsCorrespondence.columnDefs[5].visible = ($scope.search.status !== "pending");   
            }
        }

        $scope.changeStatus = function (status) {
                
            $scope.search.status = status;
/*            if (angular.isDefined($scope.gridOptionsCorrespondence)) {
                $scope.gridOptionsCorrespondence.columnDefs[5].visible = (status !== "pending");
                $scope.gridOptionsCorrespondence.columnDefs[6].visible = (pigstoShowInList.length > 0);
            }*/
            $scope.loadData();
        }

        $scope.changeStatus("pending");

        $scope.goToEdit = function (rowEntity) {
            var idx = 0;
            $scope.correspondences.forEach(function (row, index) {
                if (row.id == rowEntity.id) idx = index;
            });

            var savedOptions = JSON.parse(localStorage.getItem("correspondences_options"));
            var offset = (savedOptions._page- 1) * savedOptions._pageSize;
            savedOptions.row_index = offset + idx;
            savedOptions._page = savedOptions.row_index + 1;
            localStorage.setItem("correspondences_options", JSON.stringify(savedOptions));

            $state.go("correspondence.edit", { id: rowEntity.id });
        }

        $scope.clearForm = function () {
            var status = $scope.search.status;
            $scope.search = { status: status, correspondence_type_id: null, pigs: [] };
            $scope.loadData();
        }

        $scope.deleteDialog = function (id, name) {
            modalService.confirm({
                title: $filter('translate')('correspondence.button_delete'),
                message: $filter('translate')('correspondence.delete_message') + " " + name + "?",
                onAccept: function () {
                    Restangular.one('Correspondences', id).remove().then(function () {
                        toastr.success($filter('translate')('correspondence.deleted_success'));
                        //$scope.gridOptionsCorrespondence.gridApi.core.raise.itemDeleted($scope);
                        $scope.loadData();

                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };

        $scope.export = function () {

            // Si el estado es "all", no enviamos filtro de estado, para que se exporten todos los estados.

            let options = {...$scope.search};
            addSpecialFiltersToOptions(options);

            var config = {
                filters: {
                    EXPORT_TYPE: "CORRESPONDENCE",
                    TYPE: options.correspondence_type_id,
                    STATUS: options.status == 'all' ? null : options.status, 
                    FROM_PERSON_ID: options.from_person_id,
                    FROM_NAME: options.from_name,
                    FROM_POSITION_ID: options.from_position_id,
                    TO_PERSON_ID: options.to_person_id,
                    TO_NAME: options.to_name,
                    DESCRIPTION: options.description,
                    DATE_FROM: options.date_from,
                    DATE_TO: options.date_to
                }
            }

            datasetsService.exportByType("correspondence", config);

        };





        $scope.print_pending = function (code) {

            let options = {...$scope.search};
            addSpecialFiltersToOptions(options);

            var configOptions = {
                filters: {
                    CORRESPONDENCE_TYPE_ID: options.correspondence_type_id != null ? options.correspondence_type_id : undefined, 
                    STATUS: options.status == 'all' ? null : options.status,
                    FROM_PERSON_ID: options.from_person_id != null ? options.from_person_id : undefined,
                    FROM_NAME: options.from_name,
                    TO_PERSON_ID: options.to_person_id != null ? options.to_person_id : undefined,
                    TO_NAME: options.to_name,
                    FROM_POSITION_ID: options.from_position_id != null ? options.from_position_id : undefined,
                    DESCRIPTION: options.name,
                    DATE_FROM: options.date_from != null ? options.date_from : undefined,
                    DATE_TO: options.date_to != null ? options.date_to : undefined,
                    DATE_CELEBRATION_TO: options.date_celebration_to != null ? options.date_celebration_to : undefined,
                    DATE_CELEBRATION_FROM: options.date_celebration_from != null ? options.date_celebration_from : undefined
                }
            };

            $http({
                method: 'get',
                url: (window as any).CONFIG.api_url + 'Documents/GetDocumentsByDocumentCode',
                params: { code: code, filters: configOptions.filters }
            }).then(function (results, status, headers, config) {
                
                if (results.data.rows.length > 0) {
                    var item = results.data.rows[0];
                    $http({
                        method: 'post',
                        url: (window as any).CONFIG.api_url + 'documentgenerator/Generate',
                        params: { document_id: item.id, outputType: 'pdf', filters: configOptions?.filters ?? {} }
                    }).then(function (result, status, headers, config) {
                        let url = (window as any).CONFIG.api_url + 'documentgenerator/download/' + result.data;
                        window.open(url, '_blank');
                    });
                }
            }); 


        };


        // Función auxiliar para los añadir los filtros de cargo, personas y destinatarios. Que tienen una lógica particular 
        let addSpecialFiltersToOptions = function (options) {
            
                            if (typeof $scope.search.from_person === 'string') {
                               options.from_name = $scope.search.from_person;
                            } else if (typeof $scope.search.from_person === 'object' && $scope.search.from_person != null) {
                                if ($scope.search.from_person.id > 0) { // Por algún motivo no siempre tienen ID
                                    options.from_person_id = $scope.search.from_person.id;
                                } else {
                                    options.from_person_id = null;
                                    options.from_name = $scope.search.from_person.name; // ni no tiene ID, lo hacemos con simplemente el nombre
                                }
                            }
                            
                            // De manera similar a como lo hacemos con from_person,  comprobamos el filtro de to_person.
                            if (typeof $scope.search.to_person === 'string') {
                               options.to_name = $scope.search.to_person;
                            } else if (typeof $scope.search.to_person === 'object' && $scope.search.to_person != null) {
                                if ($scope.search.to_person.id > 0) { // Por algún motivo no siempre tienen ID
                                    options.to_person_id = $scope.search.to_person.id;
                                } else {
                                    options.to_person_id = null;
                                    options.to_name = $scope.search.to_person.name; // ni no tiene ID, lo hacemos con simplemente el nombre
                                }
                            }

                            if (typeof $scope.search.from_position === 'string') {
                                options.from_position_name = $scope.search.from_position;
                            } else if (typeof $scope.search.from_position === 'object' && $scope.search.from_position != null) {
                                if ($scope.search.from_position.id > 0) {
                                    options.from_position_id = $scope.search.from_position.id;
                                } else {
                                    options.from_position_name = $scope.search.from_position.name; // ni no tiene ID, lo hacemos con simplemente el nombre
                                }
                            }

                        return options;
        }

    }])

;